<template>
  <div v-if="visible" id="tabVesselEq" class="tab-vessel-eq">
    <div style="display:flex;flex-direction:row;">
      <div v-show="(showBookingEdi1 && showButton) || !readonly" class="section">
        <div class="operations">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-menu
                v-show="showBookingEdi1 && showButton"
                text-color="#404144"
                active-text-color="#404144"
                mode="horizontal"
                class="el-menu-button el-button el-button--primary el-button--mini"
                style="width: 90px;vertical-align: top"
                @select="toBooking"
              >
                <el-submenu :disabled="bookingEdi1Disabled || !(action === 'look' && form.uuid)" index="index">
                  <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIBooking') }}</span>
                  <el-submenu index="original">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item index="API0" :disabled="!bookingEDIApiOpen">API</el-menu-item>
                    <el-menu-item index="FTP1">FTP</el-menu-item>
                  </el-submenu>
                  <el-submenu index="correct">
                    <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                    <el-menu-item index="FTP0">FTP</el-menu-item>
                    <el-menu-item index="API1" :disabled="!bookingEDIApiOpen">API</el-menu-item>
                  </el-submenu>
                  <el-submenu index="shutOut">
                    <template slot="title">{{ $t('SeaExport.ShutOut') }}</template>
                    <el-menu-item index="FTP2">FTP</el-menu-item>
                    <el-menu-item index="API2" :disabled="true">API</el-menu-item>
                  </el-submenu>
                  <el-menu-item v-if="seAllowReceiptImport" :index="$t('SeaExport.ReceiptImport')">{{ $t('SeaExport.ReceiptImport') }}</el-menu-item>
                </el-submenu>
              </el-menu>
              <el-button no="1" type="primary" class="can-operate" @click="loadBookingLog">{{ $t('CargoMsg.Cargo_BookingLog') }}</el-button>
              <el-button v-show="$checkPermission(['button_SEBooking_Subscription'])" no="bookingSubscribe" type="primary" class="can-operate" @click="subscribeSeaBooking">{{ $t('CargoMsg.Cargo_BookingSubscribe') }}</el-button>
              <el-button v-show="$checkPermission(['button_SEBooking_Subscription'])" no="bookingSubscribeSync" type="primary" class="can-operate" @click="subscribeSeaBookingSync">{{ $t('CargoMsg.Cargo_BookingSubscribeSync') }}</el-button>
              <el-button v-show="$checkPermission(['button_SEBooking_Subscription'])" no="bookingSubscriptionStatus" type="primary" class="can-operate" @click="openSubscriptionStatusDialog">{{ $t('CargoMsg.Cargo_BookingSubscriptionStatus') }}</el-button>
              <el-button v-show="!readonly && [1, 2, 3].includes(isInputMbl)" v-permission="['button_SEBooking_generateMBL']" no="2" type="primary" @click="generateMblNo">{{ $t('SeaExport.GeneratePrimaryDocNo') }}</el-button>
              <el-button v-show="!readonly && form.mbl && [1, 2, 3].includes(isInputMbl)" v-permission="['button_SEBooking_generateSoNo']" no="3" type="primary" @click="generateSoNo">{{ $t('SeaExport.AddSpellCustomsOrderNo') }}</el-button>
              <el-button v-show="readonly && form.mbl && form.masterFlag && [1, 2, 3].includes(isInputMbl)" v-permission="['button_SEBooking_generateMBL']" no="4" type="primary" @click="allocateSoNo">{{ $t('SeaExport.DistributionCustomsNo') }}</el-button>
              <el-checkbox v-show="enableShipperConsignNotify" v-model="form.shipperLock" no="shipperLock" style="margin-left: 5px;" :disabled="enableShipperLock">{{ $t('SeaExport.ShipperLocked') }}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="padding-left: 0">
        <el-button
          v-show="form.uuid && showResubscribeBookingReceipt && canSubscribeReceipt && [SystemConstants.JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code, SystemConstants.JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code].indexOf(form.bookingState) > -1"
          no="resubscribeBookingReceipt"
          type="primary"
          @click="subscribeReceiptExec"
        >
          {{ $t('CargoMsg.Cargo_ResubscribeBookingReceipt') }}
        </el-button>
      </div>
    </div>
    <tab-vessel-eq-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.vesselAndVoyage && elementDict.vesselAndVoyage.viewable && showVessel" slot="vesselAndVoyage">
        <line-label slot="label" :class="elementDict.vesselAndVoyage.isRequire ? 'blue' : ''" :label="elementDict.vesselAndVoyage.label" />
        <el-input v-model="form.vesselAndVoyage" :class="importDifferenceField.vesselAndVoyage ? 'red-border' : ''" no="vesselAndVoyage" :disabled="readonlyVessel || !elementDict.vesselAndVoyage.writable" @input="(value) => pm.onVesselAndVoyageChange(value)" />
      </el-form-item>
      <el-form-item v-if="elementDict.vessel && elementDict.vessel.viewable" slot="vessel">
        <line-label slot="label" :class="fieldClass.vesselTitle?fieldClass.vesselTitle:(elementDict.vessel.isRequire ? 'blue' : '')" :label="elementDict.vessel.label" />
        <cargo-advance-select
          no="5"
          :disabled="!pm.lclslaveEnabledExcludeExportToImport || !elementDict.vessel.writable"
          :select-type="selectTypeNames.static_data_Vessel"
          :cache="false"
          filterable
          :allow-create="pm._allowEditingVessel"
          :default-value="form.vessel"
          :static-options="pm.vesselList"
          :class="importDifferenceField.vessel ? fieldClass.vessel + ' red-border' : fieldClass.vessel"
          :latest-used-data-key="elementDict.vessel.userCustomContent && elementDict.vessel.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-vessel' : ''"
          @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.voyageFlight && elementDict.voyageFlight.viewable" slot="voyageFlight">
        <line-label slot="label" :class="fieldClass.voyageFlightTitle?fieldClass.voyageFlightTitle:(elementDict.voyageFlight.isRequire ? 'blue' : '')" :label="elementDict.voyageFlight.label" />
        <div style="display: flex">
          <cargo-advance-select
            ref="voyageFlight"
            no="6"
            :static-options="pm._voyages || []"
            :cache="false"
            :default-value="form.voyageFlight"
            :disabled="!pm.lclslaveEnabledExcludeExportToImport || !elementDict.voyageFlight.writable"
            filterable
            clearable
            :allow-create="pm.editVoyageMode===1"
            :class="importDifferenceField.voyageFlight ? fieldClass.voyageFlight + ' red-border' : fieldClass.voyageFlight"
            tag-name="voyageNo"
            tag-value="voyageNo"
            :filter-tag-names="['voyageNo']"
            :latest-used-data-key="elementDict.voyageFlight.userCustomContent && elementDict.voyageFlight.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-voyageFlight' : ''"
            @focus="pm.txtVoyageFocusInHandler()"
            @parentCallBack="p=>{pm.onVoyageFlightChange(p)}"
          />
          <!--船期选择器-->
          <span
            v-show="isSelectVesselSchedule && action !== 'look'"
            class="el-button el-button--primary el-button--mini"
            style="min-width:40px!important;margin-left:2px"
            @click="btnVayageShowHandle"
          >
            <i class="el-icon-search" />
          </span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.carrierVoyage && elementDict.carrierVoyage.viewable" slot="carrierVoyage">
        <line-label slot="label" :class="elementDict.carrierVoyage.isRequire ? 'blue' : ''" :label="elementDict.carrierVoyage.label" />
        <el-input v-model="form.carrierVoyage" :class="importDifferenceField.carrierVoyage ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || canEditInternalDelegatedJobField || !elementDict.carrierVoyage.writable" no="carrierVoyage" />
      </el-form-item>
      <el-form-item v-if="elementDict.soNo && elementDict.soNo.viewable" slot="soNo">
        <line-label slot="label" :class="fieldClass.soNoTitle?fieldClass.soNoTitle:(elementDict.soNo.isRequire ? 'blue' : '')" :label="elementDict.soNo.label" />
        <so-no-input v-model="form.soNo" :disabled="readonlyExcludeExportToImport || slaveCustomsDeclarationEnable || !elementDict.soNo.writable" :class="fieldClass.soNo" @blur="mblBlur(form.soNo, true)" />
      </el-form-item>
      <el-form-item v-if="elementDict.mbl && elementDict.mbl.viewable" slot="mbl">
        <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
        <div style="display: flex;flex-direction: row;padding-right: 3px;">
          <el-input v-show="[0, 2, 3].includes(isInputMbl)" v-model="form.mbl" no="7" :disabled="readonlyExcludeExportToImport || !elementDict.mbl.writable" :class="form.mbl==='CANCELLED'?'mbl-red':''" @change="pm.changeMbl()" @blur="mblBlur(form.mbl, false)" />
          <el-input v-show="[1].includes(isInputMbl)" v-model="form.mbl" no="8" :disabled="readonlyExcludeExportToImport || !mblEditable || !elementDict.mbl.writable" :class="form.mbl==='CANCELLED'?'mbl-red':''" @input="mblConfig.curRule = null" @change="pm.changeMbl()" @blur="mblBlur(form.mbl, false)" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.bookingNo && elementDict.bookingNo.viewable" slot="bookingNo">
        <line-label slot="label" :class="elementDict.bookingNo.isRequire ? 'blue' : ''" :label="elementDict.bookingNo.label" />
        <el-input v-model="form.bookingNo" :disabled="readonlyExcludeExportToImport || !elementDict.bookingNo.writable" no="9" />
      </el-form-item>
      <el-form-item v-if="elementDict.stationCode && elementDict.stationCode.viewable" slot="stationCode">
        <line-label slot="label" :class="elementDict.stationCode.isRequire ? 'blue' : ''" :label="elementDict.stationCode.label" />
        <el-select
          v-model="form.stationCode"
          no="10"
          filterable
          clearable
          :disabled="readonlyExcludeExportToImport || !elementDict.stationCode.writable"
          :placeholder="$t('common.defaultPlaceholder')"
        >
          <el-option
            v-for="item in stationOptions"
            :key="item.value"
            :label="`${item.label}(${item.value})`"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.scNo && elementDict.scNo.viewable" slot="scNo">
        <line-label slot="label" :class="elementDict.scNo.isRequire ? 'blue' : ''" :label="elementDict.scNo.label" />
        <!-- 只能手动输入 -->
        <el-input
          v-if="sCNumberSelectMethod === 0"
          v-model="form.scNo"
          no="10"
          :style="isTP ? 'width: 75%;display: inline-block' : ''"
          :disabled="readonlyExcludeExportToImport || !elementDict.scNo.writable"
          :placeholder="$t('common.defaultPlaceholder')"
        />
        <!-- 只能选择 -->
        <cargo-advance-select
          v-else-if="sCNumberSelectMethod === 1"
          ref="scNoSelect"
          no="10"
          filterable
          :style="isTP ? 'width: 75%;display: inline-block' : ''"
          :allow-create="false"
          :select-type="selectTypeNames.basic_data_ShippingContract"
          :static-options="shippingContractList"
          :tag-value="'contractNumber'"
          :default-value="form.scNo"
          :disabled="readonlyExcludeExportToImport || !elementDict.scNo.writable"
          :placeholder="$t('common.defaultPlaceholder')"
          @parentCallBack="p=>{pm.onscNoChange(p)}"
        />
        <!-- 可以选择、可以手工输入 -->
        <cargo-advance-select
          v-else
          ref="scNoSelect"
          no="10"
          filterable
          :style="isTP ? 'width: 75%;display: inline-block' : ''"
          :allow-create="true"
          :disabled="readonlyExcludeExportToImport || !elementDict.scNo.writable"
          :select-type="selectTypeNames.basic_data_ShippingContract"
          :static-options="shippingContractList"
          :tag-value="'contractNumber'"
          :default-value="form.scNo"
          :placeholder="$t('common.defaultPlaceholder')"
          @parentCallBack="p=>{pm.onscNoChange(p)}"
        />
        <el-select
          v-if="isTP"
          v-model="form.scNoType"
          :disabled="readonlyExcludeExportToImport || !elementDict.scNo.writable"
          no="flashPointUnit"
          style="width: 25%;display: inline-block"
          placeholder=""
        >
          <el-option
            v-for="(item,index) in scNoTypeArray"
            :key="index"
            :label="isZh ? item.chineseName : item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <!--              <el-form-item :label="$t('SeaExport.InnerContractNo')">-->
      <!--                <el-input v-model="form.contractNo" />-->
      <!--              </el-form-item>-->
      <el-form-item v-show="elementDict.contractNo && elementDict.contractNo.viewable" slot="contractNo">
        <line-label slot="label" :class="elementDict.contractNo.isRequire ? 'blue' : ''" :label="elementDict.contractNo.label" />
        <cargo-advance-select
          ref="contractNo"
          no="11"
          :static-options="availableContractNos"
          :cache="false"
          :default-value="form.contractNo"
          :disabled="readonlyExcludeExportToImport || !pm.lclslaveEnabledExcludeExportToImport || !elementDict.contractNo.writable"
          filterable
          clearable
          :allow-create="true"
          :class="importDifferenceField.contractNo ? fieldClass.contractNo + ' red-border' : fieldClass.contractNo"
          tag-name="contractNo"
          tag-value="contractNo"
          :filter-tag-names="['contractNo']"
          @parentCallBack="onContractNoChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.quotationNum && elementDict.quotationNum.viewable" slot="quotationNum">
        <line-label slot="label" :class="elementDict.quotationNum.isRequire ? 'blue' : ''" :label="elementDict.quotationNum.label" />
        <el-input v-model="form.quotationNum" :class="importDifferenceField.quotationNum ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || !elementDict.quotationNum.writable" no="12" />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselIMO && elementDict.vesselIMO.viewable" slot="vesselIMO">
        <line-label slot="label" :class="elementDict.vesselIMO.isRequire ? 'blue' : ''" :label="elementDict.vesselIMO.label" />
        <el-input v-model="form.vesselIMO" :class="importDifferenceField.vesselIMO ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || !elementDict.vesselIMO.writable" no="13" />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierCode && elementDict.carrierCode.viewable" slot="carrierCode">
        <line-label slot="label" :class="elementDict.carrierCode.isRequire ? 'blue' : ''" :label="elementDict.carrierCode.label" />
        <el-input v-model="form.carrierCode" :class="importDifferenceField.carrierCode ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport" no="carrierCode" />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselCode && elementDict.vesselCode.viewable" slot="vesselCode">
        <line-label slot="label" :class="elementDict.vesselCode.isRequire ? 'blue' : ''" :label="elementDict.vesselCode.label" />
        <el-input v-model="form.vesselCode" no="14" :class="importDifferenceField.vesselCode ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || !pm.lclslaveEnabledExcludeExportToImport || !elementDict.vesselCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.routeCode && elementDict.routeCode.viewable" slot="routeCode">
        <line-label slot="label" :class="elementDict.routeCode.isRequire ? 'blue' : ''" :label="elementDict.routeCode.label" />
        <el-input v-model="form.routeCode" no="95" :class="importDifferenceField.routeCode ? 'red-border' : ''" :disabled="checkRouteCode || readonly || !pm.lclslaveEnabledExcludeExportToImport || !elementDict.routeCode.writable" />
      </el-form-item>
      <template v-if="elementDict.cNptNo && elementDict.cNptNo.viewable" slot="cNptNo">
        <el-form-item>
          <line-label slot="label" :class="elementDict.cNptNo.isRequire ? 'blue' : ''" :label="elementDict.cNptNo.label" />
          <cargo-repeat-value-select
            v-model="form.cNptNo"
            :placeholder="''"
            no="cNptNo"
            filterable
            :allow-create="true"
            :disabled="readonlyExcludeExportToImport || !elementDict.cNptNo.writable"
            clearable
            :options="cNptList"
            label-field="no"
            value-field="no"
            unique-field="no"
            :match-of-repeat-value="matchOfCNpt"
            @change="cNptChangeHandler"
            @handleBlur="cNptBlurHandler"
          />
        </el-form-item>
        <el-form-item :label="''">
          <el-input
            v-model="form.cNptName"
            :disabled="readonlyExcludeExportToImport || !elementDict.cNptNo.writable"
            no="cNptName"
            type="textarea"
            :rows="3"
            @dblclick.native="showAdvanceTextDialog('',form.cNptName,val=>{form.cNptName=val})"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.customerReserveVoyage && elementDict.customerReserveVoyage.viewable" slot="customerReserveVoyage">
        <line-label slot="label" :class="elementDict.customerReserveVoyage.isRequire ? 'blue' : ''" :label="elementDict.customerReserveVoyage.label" />
        <el-input v-model="form.customerReserveVoyage" no="customerReserveVoyage" :disabled="readonlyExcludeExportToImport || !elementDict.customerReserveVoyage.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.na && elementDict.na.viewable" slot="na">
        <line-label slot="label" :class="elementDict.na.isRequire ? 'blue' : ''" :label="elementDict.na.label" />
        <div style="display: flex">
          <cargo-advance-select
            no="15"
            :static-options="pm.nacList || []"
            :cache="false"
            :default-value="form.na"
            :disabled="readonlyExcludeExportToImport || !elementDict.na.writable"
            filterable
            clearable
            :allow-create="true"
            tag-name="nac"
            tag-value="nac"
            :filter-tag-names="['nac']"
            @parentCallBack="p=>{form.na = p.value}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.naCode && elementDict.naCode.viewable" slot="naCode">
        <line-label slot="label" :class="elementDict.naCode.isRequire ? 'blue' : ''" :label="elementDict.naCode.label" />
        <el-input v-model="form.naCode" :disabled="readonlyExcludeExportToImport || !elementDict.naCode.writable" no="16" />
      </el-form-item>
      <el-form-item v-if="elementDict.laneCode && elementDict.laneCode.viewable" slot="laneCode">
        <line-label slot="label" :class="elementDict.laneCode.isRequire ? 'blue' : ''" :label="elementDict.laneCode.label" />
        <el-input v-model="form.laneCode" :disabled="readonlyExcludeExportToImport || !elementDict.laneCode.writable" no="17" />
      </el-form-item>
      <el-form-item v-if="elementDict.shippingCompanySpecificCode && elementDict.shippingCompanySpecificCode.viewable" slot="shippingCompanySpecificCode">
        <line-label slot="label" :class="elementDict.shippingCompanySpecificCode.isRequire ? 'blue' : ''" :label="elementDict.shippingCompanySpecificCode.label" />
        <cargo-advance-select
          ref="shippingCompanySpecificCode"
          no="shippingCompanySpecificCode"
          :static-options="shippingCompanySpecificCodeList"
          :cache="false"
          :default-value="form.shippingCompanySpecificCode"
          :disabled="readonlyExcludeExportToImport || !elementDict.shippingCompanySpecificCode.writable"
          filterable
          clearable
          :allow-create="true"
          :class="importDifferenceField.shippingCompanySpecificCode ? fieldClass.shippingCompanySpecificCode + ' red-border' : fieldClass.shippingCompanySpecificCode"
          tag-name="shippingCompanySpecificCode"
          tag-value="shippingCompanySpecificCode"
          :filter-tag-names="['shippingCompanySpecificCode']"
          @parentCallBack="p=>{form.shippingCompanySpecificCode = p.value}"
        />
      </el-form-item>

      <el-form-item v-if="elementDict.subContractNo.viewable" slot="subContractNo">
        <line-label slot="label" :class="elementDict.subContractNo.isRequire ? 'blue' : ''" :label="elementDict.subContractNo.label" />
        <el-input v-model="form.subContractNo" :disabled="readonlyExcludeExportToImport || !elementDict.subContractNo.writable" no="18" />
      </el-form-item>
      <!-- 港区 -->
      <el-form-item v-if="elementDict.portDistrict.viewable" slot="portDistrict" class="warn-label">
        <div slot="label" :class="elementDict.portDistrict.isRequire ? 'blue' : ''" style="display: flex;flex-direction: row-reverse;float: right;width: 100%;">
          <span :title="elementDict.portDistrict.label" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ elementDict.portDistrict.label }}</span>
          <el-button
            v-if="shippingSchedules && shippingSchedules.length > 1"
            :disabled="readonlyExcludeExportToImport || readonly || !elementDict.portDistrict.writable"
            no="showMoreShippingSchedules"
            type="primary"
            style="margin-right: 10px"
            @click="showMoreShippingScheduleDialog"
          >{{ $t('CargoMsg.Cargo_ChooseShippingSchedules') }}
          </el-button>
        </div>
        <el-input
          v-model="form.portDistrict"
          no="19"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.portDistrict.writable"
          :class="fieldClass.portDistrict"
        />
      </el-form-item>
      <!-- 开港时间 -->
      <el-form-item v-if="elementDict.terminalOpendate.viewable" slot="terminalOpendate" class="warn-label">
        <line-label slot="label" :class="elementDict.terminalOpendate.isRequire ? 'blue' : ''" :label="elementDict.terminalOpendate.label" />
        <el-date-picker
          v-model="form.terminalOpendate"
          no="20"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.terminalOpendate.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :class="fieldClass.terminalOpendate"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 港区截港时间 -->
      <el-form-item v-if="elementDict.terminalCutoff.viewable" slot="terminalCutoff" class="warn-label">
        <line-label slot="label" :class="elementDict.terminalCutoff.isRequire ? 'blue' : ''" :label="elementDict.terminalCutoff.label" />
        <el-date-picker
          v-model="form.terminalCutoff"
          no="21"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.terminalCutoff.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :class="fieldClass.terminalCutoff"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierCyCutOffTime.viewable" slot="carrierCyCutOffTime">
        <line-label slot="label" :class="elementDict.carrierCyCutOffTime.isRequire ? 'blue' : ''" :label="elementDict.carrierCyCutOffTime.label" />
        <el-date-picker
          v-model="form.carrierCyCutOffTime"
          no="22"
          :disabled="readonlyExcludeExportToImport || Boolean(form.lclMasterUuid) || !elementDict.carrierCyCutOffTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="importDifferenceField.carrierCyCutOffTime ? 'red-border' : ''"
        />
      </el-form-item>
      <!-- 计划靠泊时间 -->
      <el-form-item v-if="elementDict.berthPlanDate.viewable" slot="berthPlanDate" class="warn-label">
        <line-label slot="label" :class="elementDict.berthPlanDate.isRequire ? 'blue' : ''" :label="elementDict.berthPlanDate.label" />
        <el-date-picker
          v-model="form.berthPlanDate"
          no="23"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.berthPlanDate.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :class="fieldClass.berthPlanDate"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 计划离泊时间 -->
      <el-form-item v-if="elementDict.unBerthPlanDate.viewable" slot="unBerthPlanDate" class="warn-label">
        <line-label slot="label" :class="elementDict.unBerthPlanDate.isRequire ? 'blue' : ''" :label="elementDict.unBerthPlanDate.label" />
        <el-date-picker
          v-model="form.unBerthPlanDate"
          no="24"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.unBerthPlanDate.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :class="fieldClass.unBerthPlanDate"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 当前计划靠泊时间 -->
      <el-form-item v-if="elementDict.currentETA && elementDict.currentETA.viewable && isXycw" slot="currentETA">
        <line-label slot="label" :class="elementDict.currentETA.isRequire ? 'blue' : ''" :label="elementDict.currentETA.label" />
        <el-date-picker
          v-model="form.currentETA"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.currentETA.writable"
          no="103"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 当前计划离泊时间 -->
      <el-form-item v-if="elementDict.currentETD && elementDict.currentETD.viewable && isXycw" slot="currentETD">
        <line-label slot="label" :class="elementDict.currentETD.isRequire ? 'blue' : ''" :label="elementDict.currentETD.label" />
        <el-date-picker
          v-model="form.currentETD"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.currentETD.writable"
          no="104"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际靠泊时间 -->
      <el-form-item v-if="elementDict.actualBerthPlanDate.viewable" slot="actualBerthPlanDate" class="warn-label">
        <line-label slot="label" :class="elementDict.actualBerthPlanDate.isRequire ? 'blue' : ''" :label="elementDict.actualBerthPlanDate.label" />
        <el-date-picker
          v-model="form.actualBerthPlanDate"
          no="25"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.actualBerthPlanDate.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :class="fieldClass.actualBerthPlanDate"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际离泊时间 -->
      <el-form-item v-if="elementDict.actualUnBerthPlanDate.viewable" slot="actualUnBerthPlanDate" class="warn-label">
        <line-label slot="label" :class="elementDict.actualUnBerthPlanDate.isRequire ? 'blue' : ''" :label="elementDict.actualUnBerthPlanDate.label" />
        <el-date-picker
          v-model="form.actualUnBerthPlanDate"
          no="26"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.actualUnBerthPlanDate.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :class="fieldClass.actualUnBerthPlanDate"
          style="width: 100%"
          @input="actualUnBerthPlanDateChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.berthPlanPlace.viewable" slot="berthPlanPlace">
        <line-label slot="label" :class="elementDict.berthPlanPlace.isRequire ? 'blue' : ''" :label="elementDict.berthPlanPlace.label" />
        <el-input
          v-model="form.berthPlanPlace"
          no="27"
          :disabled="readonlyExcludeExportToImport || Boolean(form.lclMasterUuid) || !elementDict.berthPlanPlace.writable"
          :class="fieldClass.berthPlanPlace"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.actualBerthPlanPlace.viewable" slot="actualBerthPlanPlace">
        <line-label slot="label" :class="elementDict.actualBerthPlanPlace.isRequire ? 'blue' : ''" :label="elementDict.actualBerthPlanPlace.label" />
        <el-input
          v-model="form.actualBerthPlanPlace"
          no="28"
          :disabled="readonlyExcludeExportToImport || Boolean(form.lclMasterUuid) || !elementDict.actualBerthPlanPlace.writable"
          :class="fieldClass.actualBerthPlanPlace"
        />
      </el-form-item>
      <!-- 实际进港日期 -->
      <el-form-item v-if="elementDict.realArrivalsDate.viewable" slot="realArrivalsDate">
        <line-label slot="label" :class="elementDict.realArrivalsDate.isRequire ? 'blue' : ''" :label="elementDict.realArrivalsDate.label" />
        <el-date-picker
          v-model="form.realArrivalsDate"
          no="29"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.realArrivalsDate.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="fieldClass.realArrivalsDate"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.returnPeriodBegin.viewable" slot="returnPeriodBegin">
        <line-label slot="label" :class="elementDict.returnPeriodBegin.isRequire ? 'blue' : ''" :label="elementDict.returnPeriodBegin.label" />
        <el-date-picker
          v-model="form.returnPeriodBegin"
          :disabled="readonlyExcludeExportToImport || !elementDict.returnPeriodBegin.writable"
          no="30"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.returnPeriodEnd.viewable" slot="returnPeriodEnd">
        <line-label slot="label" :class="elementDict.returnPeriodEnd.isRequire ? 'blue' : ''" :label="elementDict.returnPeriodEnd.label" />
        <el-date-picker
          v-model="form.returnPeriodEnd"
          :disabled="readonlyExcludeExportToImport || !elementDict.returnPeriodEnd.writable"
          no="31"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计到港时间 -->
      <el-form-item v-if="elementDict.estimatedArrivalTime.viewable && showButton" slot="estimatedArrivalTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedArrivalTime.label" />
        <el-date-picker
          v-model="form.estimatedArrivalTime"
          no="32"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedArrivalTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际到港时间 -->
      <el-form-item v-if="elementDict.actualArrivalTime.viewable && showButton" slot="actualArrivalTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.actualArrivalTime.label" />
        <el-date-picker
          v-model="form.actualArrivalTime"
          no="33"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.actualArrivalTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          @input="actualArrivalTimeChangeHandler"
        />
      </el-form-item>
      <!-- 当前计划到港时间 -->
      <el-form-item v-if="elementDict.currentArrivalTime && elementDict.currentArrivalTime.viewable && isXycw && showButton" slot="currentArrivalTime">
        <line-label slot="label" :class="elementDict.currentArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.currentArrivalTime.label" />
        <el-date-picker
          v-model="form.currentArrivalTime"
          no="33"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.currentArrivalTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计卸船时间 -->
      <el-form-item v-if="elementDict.estimatedPortDischargeTime.viewable && showButton" slot="estimatedPortDischargeTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedPortDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedPortDischargeTime.label" />
        <el-date-picker
          v-model="form.estimatedPortDischargeTime"
          no="estimatedPortDischargeTime"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedPortDischargeTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际卸船时间 -->
      <el-form-item v-if="elementDict.portDischargeTime.viewable && showButton" slot="portDischargeTime" class="warn-label">
        <line-label slot="label" :class="elementDict.portDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.portDischargeTime.label" />
        <el-date-picker
          v-model="form.portDischargeTime"
          no="34"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.portDischargeTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计铁路运输时间 -->
      <el-form-item v-if="elementDict.estimatedRailwayDepartureTime.viewable && showButton" slot="estimatedRailwayDepartureTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedRailwayDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedRailwayDepartureTime.label" />
        <el-date-picker
          v-model="form.estimatedRailwayDepartureTime"
          no="estimatedRailwayDepartureTime"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedRailwayDepartureTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际铁路运输时间 -->
      <el-form-item v-if="elementDict.railwayDepartureTime.viewable && showButton" slot="railwayDepartureTime" class="warn-label">
        <line-label slot="label" :class="elementDict.railwayDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.railwayDepartureTime.label" />
        <el-date-picker
          v-model="form.railwayDepartureTime"
          no="35"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.railwayDepartureTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计铁路卸货时间 -->
      <el-form-item v-if="elementDict.estimatedRailwayDischargeTime.viewable && showButton" slot="estimatedRailwayDischargeTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedRailwayDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedRailwayDischargeTime.label" />
        <el-date-picker
          v-model="form.estimatedRailwayDischargeTime"
          no="estimatedRailwayDischargeTime"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedRailwayDischargeTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际铁路卸货时间 -->
      <el-form-item v-if="elementDict.railwayDischargeTime.viewable && showButton" slot="railwayDischargeTime" class="warn-label">
        <line-label slot="label" :class="elementDict.railwayDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.railwayDischargeTime.label" />
        <el-date-picker
          v-model="form.railwayDischargeTime"
          no="36"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.railwayDischargeTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计抵达交货地时间 -->
      <el-form-item v-if="elementDict.estimatedArrivalPlaceOfDelivery.viewable && showButton" slot="estimatedArrivalPlaceOfDelivery" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedArrivalPlaceOfDelivery.isRequire ? 'blue' : ''" :label="elementDict.estimatedArrivalPlaceOfDelivery.label" />
        <el-date-picker
          v-model="form.estimatedArrivalPlaceOfDelivery"
          no="estimatedArrivalPlaceOfDelivery"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedArrivalPlaceOfDelivery.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际抵达交货地时间 -->
      <el-form-item v-if="elementDict.actualArrivalPlaceOfDelivery.viewable && showButton" slot="actualArrivalPlaceOfDelivery" class="warn-label">
        <line-label slot="label" :class="elementDict.actualArrivalPlaceOfDelivery.isRequire ? 'blue' : ''" :label="elementDict.actualArrivalPlaceOfDelivery.label" />
        <el-date-picker
          v-model="form.actualArrivalPlaceOfDelivery"
          no="actualArrivalPlaceOfDelivery"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.actualArrivalPlaceOfDelivery.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计放关时间 -->
      <el-form-item v-if="elementDict.estimatedCustomsReleaseTime.viewable && showButton" slot="estimatedCustomsReleaseTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedCustomsReleaseTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedCustomsReleaseTime.label" />
        <el-date-picker
          v-model="form.estimatedCustomsReleaseTime"
          no="37"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedCustomsReleaseTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际放关时间 -->
      <el-form-item v-if="elementDict.destPortCustomsClearanceTime.viewable && showButton" slot="destPortCustomsClearanceTime" class="warn-label">
        <line-label slot="label" :class="elementDict.destPortCustomsClearanceTime.isRequire ? 'blue' : ''" :label="elementDict.destPortCustomsClearanceTime.label" />
        <el-date-picker
          v-model="form.destPortCustomsClearanceTime"
          no="38"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.destPortCustomsClearanceTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 目的港查验 -->
      <el-form-item v-if="showButton" slot="destPortInspection" class="warn-label">
        <line-label slot="label" :label="$t('SeaExport.DestinationPortInspection')" />
        <el-switch
          v-model="form.destPortInspection"
          no="38-1"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid)"
        />
      </el-form-item>
      <!-- 目的港查验等级 -->
      <el-form-item v-if="showButton" slot="destPortInspectionLevel" class="warn-label">
        <line-label slot="label" :label="$t('SeaExport.DestinationPortInspectionLevel')" />
        <el-input
          v-model="form.destPortInspectionLevel"
          no="38-2"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid)"
        />
      </el-form-item>
      <!-- 预计提重时间 -->
      <el-form-item v-if="elementDict.estimatedPickUpTime.viewable && showButton" slot="estimatedPickUpTime" class="warn-label" :title="elementDict.estimatedPickUpTime.label">
        <line-label slot="label" :class="elementDict.estimatedPickUpTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedPickUpTime.label" />
        <el-date-picker
          v-model="form.estimatedPickUpTime"
          no="39"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.estimatedPickUpTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际提重时间 -->
      <el-form-item v-if="elementDict.actualPickUpTime.viewable && showButton" slot="actualPickUpTime" class="warn-label" :title="elementDict.actualPickUpTime.label">
        <line-label slot="label" :class="elementDict.actualPickUpTime.isRequire ? 'blue' : ''" :label="elementDict.actualPickUpTime.label" />
        <el-date-picker
          v-model="form.actualPickUpTime"
          no="40"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.actualPickUpTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedDeliveryToWarehouseTime.viewable && showButton" slot="estimatedDeliveryToWarehouseTime" :title="elementDict.estimatedDeliveryToWarehouseTime.label">
        <line-label slot="label" :class="elementDict.estimatedDeliveryToWarehouseTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryToWarehouseTime.label" />
        <el-date-picker
          v-model="form.estimatedDeliveryToWarehouseTime"
          :disabled="readonlyExcludeExportToImport || !elementDict.estimatedDeliveryToWarehouseTime.writable"
          no="41"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.deliveryTime.viewable && showButton" slot="deliveryTime" :title="elementDict.deliveryTime.label">
        <line-label slot="label" :class="elementDict.deliveryTime.isRequire ? 'blue' : ''" :label="elementDict.deliveryTime.label" />
        <el-date-picker
          v-model="form.deliveryTime"
          :disabled="readonlyExcludeExportToImport || !elementDict.deliveryTime.writable"
          no="42"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destPortDeliveryTime.viewable && showButton" slot="destPortDeliveryTime" :title="elementDict.destPortDeliveryTime.label">
        <line-label slot="label" :class="elementDict.destPortDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.destPortDeliveryTime.label" />
        <el-date-picker
          v-model="form.destPortDeliveryTime"
          :disabled="readonlyExcludeExportToImport || !elementDict.destPortDeliveryTime.writable"
          no="43"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.deliveryCompletionDate.viewable" slot="deliveryCompletionDate" :title="elementDict.deliveryCompletionDate.label">
        <line-label slot="label" :class="elementDict.deliveryCompletionDate.isRequire ? 'blue' : ''" :label="elementDict.deliveryCompletionDate.label" />
        <el-date-picker
          v-model="form.deliveryCompletionDate"
          :disabled="readonlyExcludeExportToImport || !elementDict.deliveryCompletionDate.writable"
          no="44"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.EstimatedDeliveryTime')">
        <el-date-picker
          v-model="form.estDeliveryTime"
          no="41"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.ActualDeliveryTime')">
        <el-date-picker
          v-model="form.actDeliveryTime"
          no="42"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 预计还空时间 -->
      <el-form-item v-if="elementDict.estimatedReturnTime.viewable" slot="estimatedReturnTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedReturnTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedReturnTime.label" />
        <el-date-picker
          v-model="form.estimatedReturnTime"
          no="45"
          type="datetime"
          :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.estimatedReturnTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <!-- 实际还空时间 -->
      <el-form-item v-if="elementDict.destPortReturnTime.viewable && showButton" slot="destPortReturnTime" class="warn-label">
        <line-label slot="label" :class="elementDict.destPortReturnTime.isRequire ? 'blue' : ''" :label="elementDict.destPortReturnTime.label" />
        <el-date-picker
          v-model="form.destPortReturnTime"
          no="46"
          :disabled="readonlyExcludeExportToImport || editPermissions || Boolean(form.lclMasterUuid) || !elementDict.destPortReturnTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.yardCode.viewable" slot="yardCode">
        <line-label slot="label" :class="elementDict.yardCode.isRequire ? 'blue' : ''" :label="elementDict.yardCode.label" />
        <el-input v-model="form.yardCode" :disabled="readonlyExcludeExportToImport || !elementDict.yardCode.writable" no="47" />
      </el-form-item>
      <el-form-item v-if="elementDict.portCode.viewable" slot="portCode">
        <line-label slot="label" :class="elementDict.portCode.isRequire ? 'blue' : ''" :label="elementDict.portCode.label" />
        <el-input v-model="form.portCode" :disabled="readonlyExcludeExportToImport || !elementDict.portCode.writable" no="48" :class="importDifferenceField.portCode ? 'red-border' : ''" />
      </el-form-item>
      <el-form-item v-if="elementDict.addressEIR.viewable" slot="addressEIR">
        <line-label slot="label" :class="elementDict.addressEIR.isRequire ? 'blue' : ''" :label="elementDict.addressEIR.label" />
        <el-input
          v-model="form.addressEIR"
          :disabled="readonlyExcludeExportToImport || !elementDict.addressEIR.writable"
          type="textarea"
          :rows="3"
          no="49"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.EquipmentReceiptAddress'),form.addressEIR,val=>{form.addressEIR=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.contactEIR.viewable" slot="contactEIR">
        <line-label slot="label" :class="elementDict.contactEIR.isRequire ? 'blue' : ''" :label="elementDict.contactEIR.label" />
        <el-input v-model="form.contactEIR" :disabled="readonlyExcludeExportToImport || !elementDict.contactEIR.writable" no="50" />
      </el-form-item>
      <el-form-item v-if="elementDict.phoneEIR.viewable" slot="phoneEIR">
        <line-label slot="label" :class="elementDict.phoneEIR.isRequire ? 'blue' : ''" :label="elementDict.phoneEIR.label" />
        <el-input v-model="form.phoneEIR" :disabled="readonlyExcludeExportToImport || !elementDict.phoneEIR.writable" no="51" />
      </el-form-item>
      <el-form-item v-if="elementDict.fileCutoff.viewable" slot="fileCutoff">
        <line-label slot="label" :class="elementDict.fileCutoff.isRequire ? 'blue' : ''" :label="elementDict.fileCutoff.label" />
        <el-date-picker
          v-model="form.fileCutoff"
          :disabled="readonlyExcludeExportToImport || !elementDict.fileCutoff.writable"
          no="52"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="importDifferenceField.fileCutoff ? 'red-border' : ''"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.declareCutOff.viewable" slot="declareCutOff">
        <line-label slot="label" :class="elementDict.declareCutOff.isRequire ? 'blue' : ''" :label="elementDict.declareCutOff.label" />
        <el-date-picker
          v-model="form.declareCutOff"
          :disabled="readonlyExcludeExportToImport || !elementDict.declareCutOff.writable"
          no="53"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="importDifferenceField.declareCutOff ? 'red-border' : ''"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customCutoff.viewable" slot="customCutoff">
        <line-label slot="label" :class="elementDict.customCutoff.isRequire ? 'blue' : ''" :label="elementDict.customCutoff.label" />
        <el-date-picker
          v-model="form.customCutoff"
          :disabled="readonlyExcludeExportToImport || !elementDict.customCutoff.writable"
          no="54"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="importDifferenceField.customCutoff ? 'red-border' : ''"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerCutoff.viewable" slot="customerCutoff">
        <line-label slot="label" :class="elementDict.customerCutoff.isRequire ? 'blue' : ''" :label="elementDict.customerCutoff.label" />
        <el-date-picker
          v-model="form.customerCutoff"
          :disabled="readonlyExcludeExportToImport || !elementDict.customerCutoff.writable"
          no="55"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="importDifferenceField.customerCutoff ? 'red-border' : ''"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerShutout.viewable" slot="customerShutout">
        <line-label slot="label" :class="elementDict.customerShutout.isRequire ? 'blue' : ''" :label="elementDict.customerShutout.label" />
        <el-date-picker
          v-model="form.customerShutout"
          :disabled="readonlyExcludeExportToImport || !elementDict.customerShutout.writable"
          no="56"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerFileCutoff.viewable" slot="customerFileCutoff">
        <line-label slot="label" :class="elementDict.customerFileCutoff.isRequire ? 'blue' : ''" :label="elementDict.customerFileCutoff.label" />
        <el-date-picker
          v-model="form.customerFileCutoff"
          :disabled="readonlyExcludeExportToImport || !elementDict.customerFileCutoff.writable"
          no="56"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :class="importDifferenceField.customerFileCutoff ? 'red-border' : ''"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.amsCutoff.viewable && form.ams" slot="amsCutoff">
        <line-label slot="label" :class="elementDict.amsCutoff.isRequire ? 'blue' : ''" :label="elementDict.amsCutoff.label" />
        <el-date-picker
          v-model="form.amsCutoff"
          :disabled="readonlyExcludeExportToImport || !elementDict.amsCutoff.writable"
          no="57"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.apCode.viewable" slot="apCode">
        <line-label slot="label" :class="elementDict.apCode.isRequire ? 'blue' : ''" :label="elementDict.apCode.label" />
        <el-input v-model="form.apCode" :class="importDifferenceField.apCode ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || !elementDict.apCode.writable" no="58" />
      </el-form-item>
      <el-form-item v-if="elementDict.apName.viewable" slot="apName">
        <line-label slot="label" :class="elementDict.apName.isRequire ? 'blue' : ''" :label="elementDict.apName.label" />
        <el-input v-model="form.apName" :class="importDifferenceField.apName ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || !elementDict.apName.writable" no="59" />
      </el-form-item>
      <el-form-item v-if="elementDict.freeTime.viewable" slot="freeTime">
        <line-label slot="label" :class="elementDict.freeTime.isRequire ? 'blue' : ''" :label="elementDict.freeTime.label" />
        <el-input-number
          v-model="form.freeTime"
          :disabled="readonlyExcludeExportToImport || !elementDict.freeTime.writable"
          no="60"
          :controls="false"
          class="align-left"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedPackDate.viewable && showButton" slot="estimatedPackDate">
        <line-label slot="label" :class="elementDict.estimatedPackDate.isRequire ? 'blue' : ''" :label="elementDict.estimatedPackDate.label" />
        <el-date-picker
          v-model="form.estimatedPackDate"
          :disabled="readonlyExcludeExportToImport || !elementDict.estimatedPackDate.writable"
          no="61"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.arrivalTime.viewable" slot="arrivalTime">
        <line-label slot="label" :class="elementDict.arrivalTime.isRequire ? 'blue' : ''" :label="elementDict.arrivalTime.label" />
        <el-date-picker
          v-model="form.arrivalTime"
          :disabled="readonlyExcludeExportToImport || !elementDict.arrivalTime.writable"
          no="62"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.textEntrustmentState.viewable && showEntrustmentState" slot="textEntrustmentState">
        <line-label slot="label" :class="elementDict.textEntrustmentState.isRequire ? 'blue' : ''" :label="elementDict.textEntrustmentState.label" />
        <el-input
          :disabled="true"
          :value="textEntrustmentState"
          style="width:155px"
          @dblclick.native="pm.entrustHisBtnClickHandler()"
        />
        <cargo-button-container>
          <el-button
            :disabled="readonlyExcludeExportToImport || !elementDict.textEntrustmentState.writable"
            type="primary"
            style="margin-left:2px"
            @click="pm.entrustHisBtnClickHandler()"
          >...</el-button>
        </cargo-button-container>
      </el-form-item>
      <el-form-item v-if="elementDict.secondVesselVoyage.viewable" slot="secondVesselVoyage">
        <line-label slot="label" :class="fieldClass.secondVesselVoyageTitle?fieldClass.secondVesselVoyageTitle:(elementDict.secondVesselVoyage.isRequire ? 'blue' : '')" :label="elementDict.secondVesselVoyage.label" />
        <el-input v-model="form.secondVesselVoyage" :disabled="readonlyExcludeExportToImport || !elementDict.secondVesselVoyage.writable" no="63" :class="fieldClass.secondVesselVoyage" />
      </el-form-item>
      <el-form-item v-if="elementDict.secondVoyage.viewable" slot="secondVoyage">
        <line-label slot="label" :class="fieldClass.secondVoyageTitle?fieldClass.secondVoyageTitle:(elementDict.secondVoyage.isRequire ? 'blue' : '')" :label="elementDict.secondVoyage.label" />
        <el-input v-model="form.secondVoyage" :disabled="readonlyExcludeExportToImport || !elementDict.secondVoyage.writable" no="64" :class="fieldClass.secondVoyage" />
      </el-form-item>
      <el-form-item v-if="elementDict.secondVesselETD.viewable" slot="secondVesselETD">
        <line-label slot="label" :class="elementDict.secondVesselETD.isRequire ? 'blue' : ''" :label="elementDict.secondVesselETD.label" />
        <el-date-picker v-model="form.secondVesselETD" :disabled="readonlyExcludeExportToImport || !elementDict.secondVesselETD.writable" no="65" type="date" value-format="yyyy-MM-dd" style="width: 100%" @input="secondVesselETDChange" />
      </el-form-item>
      <!-- 起运港 -->
      <el-form-item v-show="elementDict.secondPolCode.viewable" slot="secondPolCode">
        <line-label slot="label" :class="elementDict.secondPolCode.isRequire ? 'blue' : ''" :label="elementDict.secondPolCode.label" />
        <cargo-advance-select
          ref="secondPolCode"
          no="secondPolCode"
          :disabled="readonlyExcludeExportToImport || !elementDict.secondPolCode.writable"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.secondPolCode"
          tag-name="englishName"
          style="flex:1"
          @parentCallBack="p=>{form.secondPolCode=p.value;form.secondPol=p.englishName;}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.secondPol.viewable" slot="secondPol">
        <line-label slot="label" :class="elementDict.secondPol.isRequire ? 'blue' : ''" :label="elementDict.secondPol.label" />
        <el-input v-model="form.secondPol" :disabled="readonlyExcludeExportToImport || !elementDict.secondPol.writable" no="secondPol" />
      </el-form-item>
      <!-- 目的港 -->
      <el-form-item v-show="elementDict.secondPodCode.viewable" slot="secondPodCode">
        <line-label slot="label" :class="elementDict.secondPodCode.isRequire ? 'blue' : ''" :label="elementDict.secondPodCode.label" />
        <cargo-advance-select
          ref="secondPodCode"
          no="secondPodCode"
          :disabled="readonlyExcludeExportToImport || !elementDict.secondPodCode.writable"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.secondPodCode"
          tag-name="englishName"
          style="flex:1"
          @parentCallBack="p=>{form.secondPodCode=p.value;form.secondPod=p.englishName;}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.secondPod.viewable" slot="secondPod">
        <line-label slot="label" :class="elementDict.secondPod.isRequire ? 'blue' : ''" :label="elementDict.secondPod.label" />
        <el-input v-model="form.secondPod" :disabled="readonlyExcludeExportToImport || !elementDict.secondPod.writable" no="secondPod" />
      </el-form-item>
      <!-- 中转抵港 -->
      <el-form-item v-if="elementDict.secondArrivalsDate.viewable" slot="secondArrivalsDate" class="warn-label">
        <line-label slot="label" :class="elementDict.secondArrivalsDate.isRequire ? 'blue' : ''" :label="elementDict.secondArrivalsDate.label" />
        <el-date-picker v-model="form.secondArrivalsDate" no="secondArrivalsDate" :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.secondArrivalsDate.writable" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <!-- 中转卸船 -->
      <el-form-item v-if="elementDict.secondUnloadingDate.viewable" slot="secondUnloadingDate" class="warn-label">
        <line-label slot="label" :class="elementDict.secondUnloadingDate.isRequire ? 'blue' : ''" :label="elementDict.secondUnloadingDate.label" />
        <el-date-picker v-model="form.secondUnloadingDate" no="secondUnloadingDate" :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.secondUnloadingDate.writable" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <!-- 中转装船 -->
      <el-form-item v-if="elementDict.secondLoadingDate.viewable" slot="secondLoadingDate" class="warn-label">
        <line-label slot="label" :class="elementDict.secondLoadingDate.isRequire ? 'blue' : ''" :label="elementDict.secondLoadingDate.label" />
        <el-date-picker v-model="form.secondLoadingDate" no="secondLoadingDate" :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.secondLoadingDate.writable" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <!-- 中转开航 -->
      <el-form-item v-if="elementDict.secondShipmentDate.viewable" slot="secondShipmentDate" class="warn-label">
        <line-label slot="label" :class="elementDict.secondShipmentDate.isRequire ? 'blue' : ''" :label="elementDict.secondShipmentDate.label" />
        <el-date-picker v-model="form.secondShipmentDate" no="secondShipmentDate" :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.secondShipmentDate.writable" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="elementDict.fnlTm.viewable" slot="fnlTm">
        <line-label slot="label" :class="elementDict.fnlTm.isRequire ? 'blue' : ''" :label="elementDict.fnlTm.label" />
        <cargo-multi-select v-model="form.fnlTm" no="66" :disabled="readonlyExcludeExportToImport || !elementDict.fnlTm">
          <el-option
            v-for="(item,index) in FNL_TM"
            :key="index"
            :label="item.englishName"
            :value="item.code"
          />
        </cargo-multi-select>
      </el-form-item>
      <!-- 支线开航日期 -->
      <el-form-item v-if="elementDict.bargeETD.viewable" slot="bargeETD" class="warn-label">
        <line-label slot="label" :class="elementDict.bargeETD.isRequire ? 'blue' : ''" :label="elementDict.bargeETD.label" />
        <el-date-picker v-model="form.bargeETD" :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.bargeETD.writable" no="67" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <!-- 支线到岗日期 -->
      <el-form-item v-if="elementDict.bargeETA.viewable" slot="bargeETA" class="warn-label">
        <line-label slot="label" :class="elementDict.bargeETA.isRequire ? 'blue' : ''" :label="elementDict.bargeETA.label" />
        <el-date-picker v-model="form.bargeETA" :disabled="readonlyExcludeExportToImport || editPermissions || !elementDict.bargeETA.writable" no="68" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="elementDict.bargeVessel.viewable" slot="bargeVessel">
        <line-label slot="label" :class="elementDict.bargeVessel.isRequire ? 'blue' : ''" :label="elementDict.bargeVessel.label" />
        <el-input v-model="form.bargeVessel" :disabled="readonlyExcludeExportToImport || !elementDict.bargeVessel.writable" no="69" />
      </el-form-item>
      <el-form-item v-if="elementDict.bargeVoyage.viewable" slot="bargeVoyage">
        <line-label slot="label" :class="elementDict.bargeVoyage.isRequire ? 'blue' : ''" :label="elementDict.bargeVoyage.label" />
        <el-input v-model="form.bargeVoyage" :disabled="readonlyExcludeExportToImport || !elementDict.bargeVoyage.writable" no="70" @focus="form.bargeVoyage=form.bargeVoyage||'V.'" />
      </el-form-item>
      <!-- 起运港（POR） -->
      <el-form-item v-if="elementDict.bargePOL.viewable" slot="bargePOL">
        <line-label slot="label" :class="elementDict.bargePOL.isRequire ? 'blue' : ''" :label="elementDict.bargePOL.label" />
        <el-input v-model="form.bargePOL" :disabled="readonlyExcludeExportToImport || !elementDict.bargePOL.writable" no="71" />
      </el-form-item>
      <el-form-item v-if="elementDict.bargePOD.viewable" slot="bargePOD">
        <line-label slot="label" :class="elementDict.bargePOD.isRequire ? 'blue' : ''" :label="elementDict.bargePOD.label" />
        <el-input v-model="form.bargePOD" :disabled="readonlyExcludeExportToImport || !elementDict.bargePOD.writable" no="72" />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselLineCode.viewable" slot="vesselLineCode">
        <line-label slot="label" :class="elementDict.vesselLineCode.isRequire ? 'blue' : ''" :label="elementDict.vesselLineCode.label" />
        <el-input v-model="form.vesselLineCode" :disabled="readonlyExcludeExportToImport || !elementDict.vesselLineCode.writable" no="73" />
      </el-form-item>
      <el-form-item v-if="elementDict.bargeCustomCutoff.viewable" slot="bargeCustomCutoff">
        <line-label slot="label" :class="elementDict.bargeCustomCutoff.isRequire ? 'blue' : ''" :label="elementDict.bargeCustomCutoff.label" />
        <el-date-picker
          v-model="form.bargeCustomCutoff"
          :disabled="readonlyExcludeExportToImport || !elementDict.bargeCustomCutoff.writable"
          no="74"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.riverCarrierId.viewable" slot="riverCarrierId">
        <line-label slot="label" :class="elementDict.riverCarrierId.isRequire ? 'blue' : ''" :label="elementDict.riverCarrierId.label" />
        <cargo-company-select
          no="75"
          :disabled="readonlyExcludeExportToImport || !elementDict.riverCarrierId.writable"
          :method-params="{seaCmp:true}"
          :default-value="form.riverCarrierId||''"
          @change="p=>{form.riverCarrierId=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bargeRemarks.viewable" slot="bargeRemarks">
        <line-label slot="label" :class="elementDict.bargeRemarks.isRequire ? 'blue' : ''" :label="elementDict.bargeRemarks.label" />
        <el-input
          v-model="form.bargeRemarks"
          :disabled="readonlyExcludeExportToImport || !elementDict.bargeRemarks.writable"
          no="bargeRemarks"
          type="textarea"
          :rows="2"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.bargeRemarks,val=>{form.bargeRemarks=val})"
        />
      </el-form-item>
      <div v-show="enableShipperConsignNotify" slot="shipperConsignNotify" class="section form-column">
        <el-form
          :disabled="readonlyExcludeExportToImport"
          label-width="70px"
          label-position="right"
          style="height:100%"
        >
          <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
          <el-form-item class="auto-width">
            <span slot="label">{{ $t('SeaExport.Shipper') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="mblCargoDoc.shipperCode"
                :disabled="enableShipperLocked"
                no="shipperCode"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="shipperId"
                :disabled="enableShipperLocked"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="mblCargoDoc.shipperId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
              />
              <el-button
                no="reset"
                :disabled="enableShipperLocked"
                type="primary"
                style="margin-left: 5px"
                @click="pm.onClear(1)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            class="auto-width"
          >
            <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
              <cargo-input
                :ref="'shipperLine'+count"
                v-model="mblCargoDoc['shipperLine'+count]"
                :disabled="enableShipperLocked"
                :no="'shipperLine'+count"
                :auto-uppercase="isUppercase"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(mblCargoDoc,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item class="auto-width">
            <span slot="label">{{ $t('SeaExport.Consignee') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="mblCargoDoc.consigneeCode"
                :disabled="enableShipperLocked"
                no="19"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="consigneeId"
                :disabled="enableShipperLocked"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="mblCargoDoc.consigneeId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
              />
              <el-button
                no="reset"
                type="primary"
                :disabled="enableShipperLocked"
                style="margin-left: 5px"
                @click="pm.onClear(2)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            class="auto-width"
          >
            <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
              <cargo-input
                :ref="'consigneeLine'+count"
                v-model="mblCargoDoc['consigneeLine'+count]"
                :disabled="enableShipperLocked"
                :no="'consigneeLine'+count"
                :auto-uppercase="isUppercase"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(mblCargoDoc,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item class="auto-width">
            <span slot="label">{{ $t('SeaExport.NotifyParty') }}</span>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="mblCargoDoc.notifyCode"
                :disabled="enableShipperLocked"
                no="notifyCode"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="notifyId"
                :disabled="enableShipperLocked"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="mblCargoDoc.notifyId||''"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
              />
              <div style="margin-top: 5px">
                <el-button
                  no="reset"
                  type="primary"
                  :disabled="enableShipperLocked"
                  @click="pm.onClear(3)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
                <el-button
                  no="copyConsignee"
                  type="primary"
                  :disabled="enableShipperLocked"
                  style="margin-left: 5px"
                  @click="pm.onCopyConsignee()"
                >{{ $t('SeaExport.CopyTheConsignee') }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            class="auto-width"
          >
            <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
              <cargo-input
                :ref="'notifyLine'+count"
                v-model="mblCargoDoc['notifyLine'+count]"
                :no="'notifyLine'+count"
                :disabled="enableShipperLocked"
                :auto-uppercase="isUppercase"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(mblCargoDoc,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
        </el-form>
      </div>
      <el-form-item v-if="elementDict.remarksShipping.viewable" slot="remarksShipping">
        <line-label slot="label" :class="elementDict.remarksShipping.isRequire ? 'blue' : ''" :label="elementDict.remarksShipping.label" />
        <el-input
          v-model="form.remarksShipping"
          :disabled="readonlyExcludeExportToImport || !elementDict.remarksShipping.writable"
          no="76"
          type="textarea"
          :rows="5"
          style="width:395px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.ShippingAdviceRemark'),form.remarksShipping,val=>{form.remarksShipping=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarksBooking.viewable" slot="remarksBooking">
        <line-label slot="label" :class="elementDict.remarksBooking.isRequire ? 'blue' : ''" :label="elementDict.remarksBooking.label" />
        <el-input
          v-model="form.remarksBooking"
          :disabled="readonlyExcludeExportToImport || !elementDict.remarksBooking.writable"
          no="77"
          type="textarea"
          :rows="5"
          style="width:395px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.BookingConfirmationRemarks'),form.remarksBooking,val=>{form.remarksBooking=val})"
        />
      </el-form-item>
      <div v-if="isTP" slot="ediReceipt" class="section" style="width:100%">
        <span class="title">{{ $t('CargoMsg.Cargo_MultiLegVoyageManagement') }}</span>
        <div class="form-row" style="flex-direction:row;">
          <div style="display:flex;padding-bottom: 5px">
            <el-button
              no="add"
              type="primary"
              :disabled="readonly"
              @click="addClickHandler"
            >{{ $t('CargoMsg.Cargo_Add') }}
            </el-button>
            <el-button
              no="delete"
              type="danger"
              :disabled="readonly"
              @click="deleteClickHandler"
            >{{ $t('CargoMsg.Cargo_Delete') }}
            </el-button>
          </div>
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="leg.gridOptions"
            :column-defs="columnDefs"
            grid-style="height:100%;"
            :row-data="leg.rowData"
            @gridReady="params=>leg.gridApi=params.api"
          />
        </div>
      </div>
      <div v-if="ediReceipt.showEdiReceipt" slot="ediReceipt" class="section">
        <span class="title">{{ $t('SeaExport.BookingReceipt') }} ({{ $t('SeaExport.InMailOfThePrevail') }})</span>
        <booking-confirmation
          :edi-receipt-data="ediReceipt.data"
          :job-no="pm.job.jobNo"
          @syncBC="syncBC"
        />
      </div>
      <div v-if="ediReceiptCommon.showEdiReceipt" slot="ediReceiptCommon" class="section">
        <span class="title">{{ $t('SeaExport.BookingReceipt') }}</span>
        <booking-confirmation-common
          :edi-receipt-data="ediReceiptCommon.data"
          :job-no="pm.job.jobNo"
          :job="pm.job"
          :last-receipt-time="ediReceiptCommon.data[0].time"
          @showYdBookingResult="$emit('showYdBookingResult', 'tabVesselEq')"
        />
      </div>
    </tab-vessel-eq-UICustom-layout>
    <!--  特殊元素, 隐藏, 用于简单上传触发系统文件选择弹窗  -->
    <input ref="importFile" type="file" accept=".pms" style="display:none;" @change="onImportFile">
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="readonlyExcludeExportToImport" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEditExcludeExportToImport" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通高级文本弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="transAdvanceTextDialog.visible"
      :title="transAdvanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="transAdvanceTextDialog.value" :disabled="readonlyExcludeExportToImport || enableShipperLocked" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEditExcludeExportToImport" type="primary" @click="finishTransAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="transAdvanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 校验船期数据是否变更弹窗 -->
    <el-dialog
      :title="$t('SeaExport.tips')"
      :visible.sync="vesseldialog"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-indent:2em;font-size:14px;line-height: 1.5;letter-spacing: 0.5px;">{{ $t('SeaExport.ObtainedContainerAndGoodsData') }}
        <span style="color:red;font-size:14px;">{{ $t('Message.ShipName') }}{{ jobDataVessel ? jobDataVessel : $t('SeaExport.empty') }}、{{ $t('SeaExport.Sailing') }}{{ jobDataVoyageFlight ? jobDataVoyageFlight : $t('SeaExport.empty') }}</span>{{ $t('SeaExport.WithBookingTab') }}
        <span style="color:red;font-size:14px;">{{ $t('Message.ShipName') }}{{ shippingDate.vessel ? shippingDate.vessel : $t('SeaExport.empty') }}、{{ $t('SeaExport.Sailing') }}{{ shippingDate.voyageFlight ? shippingDate.voyageFlight : $t('SeaExport.empty') }}</span>
        {{ $t('SeaExport.InconsistentFromTheBillData') }}
        <br>
        <span style="font-size:14px;">{{ $t('SeaExport.InconsistentFromTheBillDataTips') }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeVessel('empty')">{{ $t('SeaExport.importEmpty') }}</el-button>
        <el-button type="primary" @click="changeVessel('notEmpty')">{{ $t('SeaExport.importNotEmpty') }}</el-button>
        <el-button @click="changeVessel('ignore')">{{ $t('SeaExport.ignore') }}</el-button>
      </span>
    </el-dialog>
    <cross-tenant-history-dialog
      :visible.sync="crossTenantHistoryDialog.visible"
      :entrustment-type="crossTenantHistoryDialog.entrustmentType"
      :job-no="crossTenantHistoryDialog.jobNo"
    />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="selectedApiCallback"
    />
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
    />
    <multi-seg-num-rules-dialog
      :visible.sync="multiSegNumRulesDialog.visible"
      @callback="multiSegNumRulesCallback"
    />

    <generate-mbl-no-dialog
      :visible="mblConfig.visible"
      :form="form"
      :config="mblConfig"
      @close="mblConfig.visible =false"
    />
    <generate-so-no-dialog
      :visible="soNoConfig.visible"
      :form="form"
      :config="soNoConfig"
      :input-mbl="isInputMbl"
      :mbl-config="mblConfig"
      @close="soNoConfig.visible =false"
    />
    <edi-guide-window
      v-if="ediBaseWindow.visible"
      ref="ediBaseWindow"
      :do-saving="doSaving"
      :global-var="globalVar"
      :visible="ediBaseWindow.visible"
      :call-back-func="ediBaseWindow.callBackFunc"
      :context="context"
      @close="ediBaseWindow.visible =false"
      @ediChangeHandler="ediChangeHandler"
    />
    <!-- 订舱日志 -->
    <booking-log-dialog
      v-if="bookingLogDialog.visible"
      :visible="bookingLogDialog.visible"
      :job-uuid="bookingLogDialog.jobUuid"
      :send-type="bookingLogDialog.sendType"
      @close="bookingLogDialog.visible=false"
    />
    <!-- 订阅详情 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="subscriptionStatusDialog.visible"
      :title="$t('CargoMsg.Cargo_BookingSubscriptionStatus')"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table
        v-loading="subscriptionStatusDialog.loading"
        :data="subscriptionStatusDialog.list"
        size="mini"
        border
        style="width: 100%"
      >
        <el-table-column prop="dataTypeName" :label="$t('CargoMsg.Cargo_SubscribeDataType')" min-width="120" />
        <el-table-column prop="subscribeStatusName" :label="$t('CargoMsg.Cargo_SubscribeStatus')" min-width="120" />
        <el-table-column prop="failReason" :label="$t('CargoMsg.Cargo_ResultMessage')" min-width="200" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="subscriptionStatusDialog.visible = false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!--    edi-type="1"-->
    <!-- 选择船期 -->
    <choose-shipping-schedules
      v-if="showMoreShippingSchedule"
      :visible="showMoreShippingSchedule"
      :job="form"
      :shipping-schedules="shippingSchedules"
      :choose-shipping-schedule="chooseShippingSchedule"
      :is-btn="isChooseShippingScheduleBtn"
      @close="closeMoreShippingScheduleDialog"
    />
    <!--船期选择器-->
    <shipping-schedule-dialog
      ref="voyageShowDialog"
      :visible.sync="voyageShowDialog"
      :callback="callbackShippingScheduleHanle"
    />
    <el-dialog
      :visible.sync="showRouteDialog"
      :title="this.$t('common.btn.confirm')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 16px;">{{ this.routeTitle }}</div>
      <el-radio-group v-model="selectedRoute">
        <el-radio v-for="item in routeOptions" :key="item" :label="item">{{ item }}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onRouteDialogConfirm">{{ this.$t('common.btn.confirm') }}</el-button>
        <el-button @click="showRouteDialog = false">{{ this.$t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabVesselEqUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEqUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabVesselEq from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEq'
import StrUtils from '@/utils/StrUtils'
import { getOpening } from '@/api/seaExport/dataTracking'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getSeaBookingSpaceSubscriptionStatus, subscribeSeaBookingSpace, subscribeSeaBookingSpaceSync } from '@/api/seaExport/seaExportJob'

export default {
  name: 'TabVesselEqUICustom',
  components: { tabVesselEqUICustomLayout },
  extends: tabVesselEq,
  props: { previewConfig: { type: Object, default: null }},
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      stationOptions: [
        { label: '港联捷场站', value: 'GLJ' },
        { label: '港联欣场站', value: 'GLX' },
        { label: '港联荣场站', value: 'GLR' },
        { label: '港联华场站', value: 'GLHUA' },
        { label: '港联海场站', value: 'GLHAI' },
        { label: '港捷丰', value: 'GJF' },
        { label: '神州场站', value: 'SZ' },
        { label: '港陆场站代码', value: 'GL' },
        { label: '大亚场站代码', value: 'DY' },
        { label: '长荣场站代码', value: 'CR' },
        { label: '珉钧场站代码', value: 'MJ' },
        { label: '克运场站代码', value: 'KY' },
        { label: '捷丰场站代码', value: 'JF' },
        { label: '胜狮场站', value: 'SS' }
      ],
      subscriptionStatusDialog: {
        visible: false,
        loading: false,
        list: []
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    ensureFixedPodInspectionElements() {
      const fixedElementNames = ['destPortInspection', 'destPortInspectionLevel']
      const elementBlocks = this.elementBlocks.map(block => ({
        ...block,
        elementNames: [...block.elementNames]
      }))
      for (const block of elementBlocks) {
        block.elementNames = block.elementNames.filter(name => !fixedElementNames.includes(name))
      }
      const targetBlock = elementBlocks.find(block => block.elementNames.includes('destPortCustomsClearanceTime')) || elementBlocks.find(block => block.elementNames.length > 0)
      if (!targetBlock) {
        this.elementBlocks = elementBlocks
        return
      }
      const insertIndex = targetBlock.elementNames.indexOf('destPortCustomsClearanceTime')
      if (insertIndex === -1) {
        targetBlock.elementNames.push(...fixedElementNames)
      } else {
        targetBlock.elementNames.splice(insertIndex + 1, 0, ...fixedElementNames)
      }
      this.elementBlocks = elementBlocks
    },
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        // 重新加载页面配置，确保 elementDict 已经初始化
        this.loadPageConfig()
        const pageType = this.$route.name === 'BookingVerify' ? UICustomConstants.SEA_VERIFY_BOOKING_VESSEL : UICustomConstants.SEA_BOOKING_VESSEL
        // 确保 elementDict 不为空且有元素
        if (this.elementDict && Object.keys(this.elementDict).length > 0) {
          UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row)
        }
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const isVerifyPage = this.$route.name === 'BookingVerify'
        const pageType = isVerifyPage ? UICustomConstants.SEA_VERIFY_BOOKING_VESSEL : UICustomConstants.SEA_BOOKING_VESSEL
        let pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId)

        // 如果是验证页面且没有找到配置，使用普通订舱页面的配置作为fallback
        if (isVerifyPage && Object.keys(pageConfig.elementDict).length === 0) {
          pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_VESSEL, this.$store.getters.currentOfficeId)
        }

        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
      this.ensureFixedPodInspectionElements()
    },
    validateForm() {
      const form = this.form
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          const label = element.fieldNames.length > 1 ? field.label : element.label
          if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabVesselEq')
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return this.superFunction()
    },
    // 数据服务订阅号更改事件
    async mblBlur(mbl, isSoNo) {
      if (!mbl) {
        return
      }
      let mbls = []
      if (isSoNo) {
        mbls = mbl.split('\n')
      } else {
        mbls.push(mbl)
      }
      if (this.openPortDataService === 0) {
        const params = {
          tenantId: this.$store.getters.tenantId
        }
        await getOpening(params).then(async(res) => {
          if (res.data) {
            // 1 则为开通
            this.openPortDataService = 1
          } else {
            // -1则为未开通
            this.openPortDataService = -1
          }
        })
      }
      for (const item of mbls) {
        if (this.openPortDataService === 1 && !/^[a-zA-Z0-9]+$/.test(item)) {
          this.$message.warning(this.$t('SeaExport.SpecialCharacters'))
          return
        }
      }
      // 调用父组件的 mblBlur 方法进行 MBL 重复校验
      if (this.$options.extends.methods && this.$options.extends.methods.mblBlur) {
        await this.$options.extends.methods.mblBlur.call(this, mbl, isSoNo)
      }
    },
    subscribeSeaBooking() {
      if (!this.form.uuid) {
        return
      }
      this.loading = getLoading4Cxt(this)
      subscribeSeaBookingSpace({ jobUuid: this.form.uuid }).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    subscribeSeaBookingSync() {
      if (!this.form.uuid) {
        return
      }
      this.loading = getLoading4Cxt(this)
      subscribeSeaBookingSpaceSync({ jobUuid: this.form.uuid }).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        this.$emit('reload')
      }).finally(() => {
        this.loading.close()
      })
    },
    openSubscriptionStatusDialog() {
      if (!this.form.uuid) {
        return
      }
      this.subscriptionStatusDialog.visible = true
      this.subscriptionStatusDialog.loading = true
      this.subscriptionStatusDialog.list = []
      getSeaBookingSpaceSubscriptionStatus({ jobUuid: this.form.uuid }).then(res => {
        this.subscriptionStatusDialog.list = res.data || []
      }).finally(() => {
        this.subscriptionStatusDialog.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
  .tab-vessel-eq {
    /deep/ .el-submenu__title{
      border-bottom: none !important;
    }
    .warn-label .el-form-item__label{
      color: orange !important;
    }
    .mbl-red{
      .el-input__inner {
        color: red !important;
      }
    }
    .change_red{
      .el-input__inner {
        color: red !important;
      }
    }
    .red-border {
      .el-input__inner,
      .el-textarea__inner {
        border: 1px solid red !important;
      }
    }
  }
</style>
